const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/index-tab-elements`,
    saveCostsTable: `${API_URL}/index-tab-element/save-costs-table`,
    saveDiscountTable: `${API_URL}/index-tab-element/save-discount-table`
};

export default apiUrls;
